module.exports = __webpack_public_path__ + "img/trace-cert.3f0e2f8c.png";